import * as React from 'react';
import useAnnouncement from '../../hooks/useAnnouncement';
import { AppContext } from '../../shared/app-context';
import { Announcement } from 'kagr-ui';

const GlobalAnnouncement = () => {
  const { state, setState } = React.useContext(AppContext);
  const [displayAnnouncement, setDisplayAnnouncement] = React.useState<boolean>(true);
  const { loading, announcement: globalAnnouncement } = useAnnouncement('global');

  React.useEffect(() => {
    if (!loading && globalAnnouncement) {
      setState({ globalAnnouncement });
      // only display the announcement if it is new or hasn't been dismissed
      if (localStorage.getItem(`globalAnnouncement`) !== globalAnnouncement) {
        localStorage.setItem('globalAnnouncement', globalAnnouncement);
        localStorage.setItem('hideGlobalAnnouncement', 'false');
        setDisplayAnnouncement(true);
      } else if (localStorage.getItem('hideGlobalAnnouncement') === 'true') {
        setDisplayAnnouncement(false);
      }
    }
  }, [loading, globalAnnouncement]);

  const hideGlobalAnnouncement = () => {
    localStorage.setItem('hideGlobalAnnouncement', 'true');
    setDisplayAnnouncement(false);
  };

  return (
    <React.Fragment>
      {displayAnnouncement && globalAnnouncement && (
        <Announcement
          type="primary"
          hasExitIcon={true}
          onClose={hideGlobalAnnouncement}
          content={state.globalAnnouncement}
        />
      )}
    </React.Fragment>
  );
};
export default GlobalAnnouncement;
